import { Outlet } from 'react-router-dom';

import { CheckoutHeader } from '@components/molecules/CheckoutHeader';
import { PoweredByAstroPay } from '@components/organisms/PoweredByAstroPay';

import { ECheckoutProduct, TCheckoutProps } from './types';

export const CheckoutTemplate = ({ product = ECheckoutProduct.CHECKOUT }: TCheckoutProps) => {
  return (
    <div className="flex flex-col bg-[#F4F6FA] p-4 min-h-screen">
      <CheckoutHeader productName={product} />

      <Outlet />

      <PoweredByAstroPay />
    </div>
  );
};
